import React from "react";
import style from "./index.module.scss";
import { Tabs } from "antd";
import AccountMode, { AccountModeProps } from "./components/AccountMode";

interface LoginComponentProps extends AccountModeProps {}

export default function LoginComponent({ ...props }: LoginComponentProps) {
    return (
        <div className={style.root}>
            <div className={style.main}>
                <div className={style.title}>白果云课堂</div>

                <div className={style.card}>
                    <Tabs defaultActiveKey="1" className={style.tab}>
                        <Tabs.TabPane tab="账号验证" key="1">
                            <AccountMode {...props} />
                        </Tabs.TabPane>
                    </Tabs>
                </div>
            </div>
        </div>
    );
}
